module.exports = __webpack_public_path__ + "assets/img/txt-title.e5522ec7.svg";